import { __awaiter } from "tslib";
import $ from "jquery";
import { createRoot } from 'react-dom/client';
import React, { useState, useEffect } from 'react';
import Item from "./Item";
import { getCityById, getCityBySlug, getCityByCoords } from '../Utils/Locate';
import Cookies from "js-cookie";
import CityChosen from "./CityChosen";
import FilterSystem from "./FilterSystem";
const axios = require('axios').default;
const ListItem = ({ vars }) => {
    const [items, setItems] = useState([]);
    const [filters, setFilters] = useState([]);
    const [chosenCity, setChosenCity] = useState(null);
    const [formData, setFormData] = useState({
        search: "",
        page: 1,
        chosenCity: null
    });
    const [attributes, setAttributes] = useState({
        locale: vars.locale,
        type: vars.type,
        category: vars.category,
        cities: [],
        dictionnary: {},
        items: [],
        itemsState: "empty",
        itemCategories: [],
        itemId: vars.id,
        mapUrl: vars.mapUrl
    });
    const [isLoaded, setIsLoaded] = useState(Array.isArray(attributes.dictionnary));
    let itemsNode;
    useEffect(() => {
        if (!isLoaded) {
            const fetchData = () => __awaiter(void 0, void 0, void 0, function* () {
                function getTranslations() {
                    let formData = new FormData();
                    formData.append("locale", attributes.locale);
                    return axios.post("/api/translations", formData).then((response) => {
                        if (response.status == 200) {
                            return response.data.translations;
                        }
                        else {
                            return [];
                        }
                    });
                }
                function getCities() {
                    let formData = new FormData();
                    formData.append("locale", attributes.locale);
                    return axios.post("/api/cities", formData).then((response) => {
                        if (response.status == 200) {
                            return response.data.cities;
                        }
                        else {
                            return [];
                        }
                    });
                }
                function getItems() {
                    let formData = new FormData();
                    formData.append("locale", attributes.locale);
                    formData.append("category", attributes.category);
                    formData.append("type", attributes.type);
                    if (attributes.itemId != null)
                        formData.append("id", attributes.itemId);
                    return axios.post("/api/items", formData).then((response) => {
                        if (response.status == 200) {
                            return response.data.items;
                        }
                        else {
                            return [];
                        }
                    });
                }
                function getCategories() {
                    if (attributes.category == "dis") {
                        let formData = new FormData();
                        formData.append("locale", attributes.locale);
                        return axios.post("/api/categories", formData).then((response) => {
                            if (response.status == 200) {
                                return response.data.categories;
                            }
                            else {
                                return [];
                            }
                        });
                    }
                    return [];
                }
                Promise.all([getTranslations(), getCities(), getItems(), getCategories()])
                    .then(function (items) {
                    let cities = items[1];
                    let elements = items[2];
                    let itemCategories = items[3];
                    elements = elements.map((element) => {
                        if (element.cityId !== void 0) {
                            element.city = getCityById(cities, element.cityId);
                            if (element.city != null)
                                element.citySlug = element.city.slug;
                        }
                        return element;
                    });
                    setAttributes(Object.assign(Object.assign({}, attributes), { dictionnary: items[0], cities: cities, items: elements, itemCategories: itemCategories, itemsState: "filled" }));
                    if (attributes.category != "adv" && attributes.type != "nearest") {
                        /* Prefilled all items with selected city */
                        if (Cookies.get("currentCity")) {
                            let chosenCity = getCityBySlug(cities, Cookies.get("currentCity"));
                            if (chosenCity != null) {
                                setFormData(Object.assign(Object.assign({}, formData), { chosenCity: { value: chosenCity.slug, label: chosenCity.name } }));
                                setChosenCity({ value: chosenCity.slug, label: chosenCity.name });
                                let allItems = elements.filter((el) => {
                                    if (chosenCity !== null)
                                        return el.citySlug === chosenCity.slug;
                                    else
                                        return true;
                                });
                                setItems(allItems);
                            }
                        }
                        else {
                            if (navigator.geolocation) {
                                navigator.geolocation.getCurrentPosition((position) => {
                                    const pos = {
                                        lat: position.coords.latitude,
                                        lng: position.coords.longitude,
                                    };
                                    let chosenCity = (getCityByCoords(cities, pos.lat, pos.lng));
                                    if (chosenCity != null) {
                                        Cookies.set("currentCity", chosenCity.slug);
                                        setFormData(Object.assign(Object.assign({}, formData), { chosenCity: { value: chosenCity.slug, label: chosenCity.name } }));
                                        setChosenCity({ value: chosenCity.slug, label: chosenCity.name });
                                        let allItems = elements.filter((el) => {
                                            if (chosenCity !== null)
                                                return el.citySlug === chosenCity.slug;
                                            else
                                                return true;
                                        });
                                        setItems(allItems);
                                    }
                                }, (err) => {
                                    setItems([...elements]);
                                }, {
                                    enableHighAccuracy: true,
                                });
                            }
                            else {
                                setItems([...elements]);
                            }
                        }
                    }
                    else {
                        setItems([...elements]);
                    }
                    //
                    setIsLoaded(true);
                });
            });
            fetchData();
        }
        else {
            /* Refresh data after updating elements */
            let allItems = attributes.items.filter((el) => {
                if (attributes.category == "dis") {
                    if (filters.length) {
                        let cat = filters.some(r => el.categories.includes(r));
                        let city = chosenCity !== null ? el.citySlug === chosenCity.value : true;
                        return cat && city;
                    }
                    else if (chosenCity !== null) {
                        return el.citySlug === chosenCity.value;
                    }
                    else
                        return true;
                }
                else {
                    if (chosenCity !== null)
                        return el.citySlug === chosenCity.value;
                    else
                        return true;
                }
            });
            setItems(allItems);
        }
        return () => {
            // this now gets called when the component unmounts
        };
    }, [chosenCity, filters]);
    const l = (label) => {
        if (attributes.dictionnary[label] !== void 0) {
            return attributes.dictionnary[label];
        }
        return label;
    };
    const handleChange = (e) => {
        let value = e.target.value;
        let data = Object.assign({}, formData);
        data.search = value;
        setFormData(data);
    };
    const handleSubmit = (e) => {
        e.preventDefault();
        let postData = new FormData();
        postData.append("s", formData.search);
    };
    const viewMore = (e) => {
        e.preventDefault();
        setFormData(Object.assign(Object.assign({}, formData), { page: formData.page + 1 }));
    };
    const handleFilter = (value) => {
        setFilters([]);
        setTimeout(() => {
            if (value == null)
                setFilters([]);
            else
                setFilters(value);
        }, 5);
    };
    const handleCityChoice = (value) => {
        setChosenCity({ slug: null, value: null });
        setTimeout(() => {
            setChosenCity(value);
            Cookies.set("currentCity", value.value);
        }, 5);
    };
    if (!isLoaded)
        return (React.createElement("div", { className: "loader" }, "Chargement en cours..."));
    if (attributes.itemsState == "filled") {
        let allItems = items;
        let numbersItems = allItems.length;
        let itemsRaw = allItems;
        let actions;
        let cityChosen;
        let filterSystem;
        if (attributes.type == "nearest") {
            itemsRaw = itemsRaw.slice(0, 2);
        }
        else {
            itemsRaw = itemsRaw.slice(0, formData.page * 4);
            // Action for Button More
            if (formData.page * 4 <= numbersItems) {
                actions = (React.createElement(React.Fragment, null,
                    React.createElement("div", { className: "more" },
                        React.createElement("a", { href: "#more", onClick: viewMore },
                            React.createElement("span", { className: "icon" },
                                React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "19", height: "19", viewBox: "0 0 19 19" },
                                    React.createElement("g", { transform: "translate(-198.073 -1778.796)" },
                                        React.createElement("line", { className: "stroke", y2: "17", transform: "translate(208.073 1779.797)", fill: "none", stroke: "#80de86", strokeLinecap: "round", strokeWidth: "2" }),
                                        React.createElement("line", { className: "stroke", x1: "17", transform: "translate(199.073 1787.797)", fill: "none", stroke: "#80de86", strokeLinecap: "round", strokeWidth: "2" })))),
                            React.createElement("span", { className: "label" }, l("viewMore"))))));
            }
            if (attributes.category != "adv") {
                cityChosen = React.createElement(CityChosen, { category: attributes.category, cities: attributes.cities, handleCityChoice: handleCityChoice, formData: formData, l: l });
            }
            // Filtering
            if (attributes.category == "dis") {
                filterSystem = React.createElement(FilterSystem, { categories: attributes.itemCategories, category: attributes.category, handleFilter: handleFilter, chosenCategories: filters, l: l });
            }
        }
        let itemsItem = (itemsRaw.map((element, index) => {
            return React.createElement(Item, { key: `item-${index}`, vars: { l: l, item: element, category: attributes.category, mapUrl: attributes.mapUrl } });
        }));
        let notLocated = React.createElement(React.Fragment, null);
        if (Cookies.get("currentCity") == null) {
            notLocated = React.createElement("div", { className: "not-located" },
                React.createElement("img", { src: "/app/themes/lumber/static/gfx/notlocated.svg", alt: "" }),
                React.createElement("h2", null, l("oops")),
                React.createElement("p", null, l("notlocatedtext")));
        }
        if (numbersItems == 0)
            itemsItem = React.createElement("div", { className: "no-result" }, l("noResults"));
        itemsNode = (React.createElement(React.Fragment, null,
            notLocated,
            cityChosen,
            filterSystem,
            React.createElement("div", { className: "items-wrapper" }, itemsItem),
            actions));
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "items" }, itemsNode)));
};
$(document).ready(() => {
    const rootElement = document.getElementById("itemnodewrapper");
    if ($(rootElement).length) {
        const root = createRoot(rootElement);
        const vars = {
            mapUrl: $(rootElement).attr("data-map"),
            locale: $(rootElement).attr("data-locale"),
            type: $(rootElement).attr("data-type"),
            category: $(rootElement).attr("data-category"),
            id: $(rootElement).attr("data-id") !== void 0 ? $(rootElement).attr("data-id") : null
        };
        root.render(React.createElement(ListItem, { vars: vars }));
    }
});
